<template>
	<div>
        <div class="row">
            <el-card class="pt-1 pb-4" shadow="always" :body-style="{ padding: '10px'}" style="width:100%;">
                <div class="row">
                    <div class="col-md-6">
                        <el-button size="mini" @click="$router.push('/performance-report/tingkat-kesehatan')"><i class="fa fa-angle-left"></i></el-button>
                    </div>
                    <div class="col-md-6 text-right">
                        <el-button size="mini" @click="toggleFullscreen"><i :class="[toggleIcon ? 'fa-compress' : 'fa-arrows-alt', 'fa']"></i></el-button>
                        <el-button size="mini" @click="$router.push('/performance-report/realisasi-abo')"><i class="fa fa-angle-right"></i></el-button>
                    </div>
                </div>

                <h4 class="text-center">RASIO KEUANGAN YTD {{ this.options.months.find(d=> d.value==this.month).name.toUpperCase() }}  {{ this.year }}</h4>

                <el-form  class="mt-2" label-position="top" label-width="100px">
                    <div class="row">
                        <div class="col-md-2">	
                            <el-form-item label="Bulan:">
                                <el-select v-model="month" clearable filterable placeholder="Select Month" size="medium" style="width:100%;">
                                    <el-option v-for="item3 in options.months" :key="item3.value" :label="item3.name" :value="item3.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="col-md-2">	
                            <el-form-item label="Tahun:" style="min-width:85px;">
                                <el-select v-model="year" clearable filterable placeholder="Select Year" size="medium" style="width:100%;">
                                    <el-option v-for="item3 in options.years" :key="item3.value" :label="item3.name" :value="item3.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="col-md-2">	
                            <el-form-item label=" ">
                                <el-button type="primary" size="medium" :loading="loading.chart" @click="applyFilter" style="width:100%;">Apply</el-button>
                            </el-form-item>
                        </div>
                        <div class="col-md-6 text-right" v-if="lastUpdate != ''">
                            <el-form-item label=" ">
                                <div v-html="lastUpdate"></div>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>

                <div class="row mt-0">
                    <div :class="(String(this.description || '').trim().length > minLengthDescription ? 'col-md-4' : 'col-md-6' ) + ' '">
                        <div>
                            <div class="text-center chart-title">Retun On Equity %</div>
                            <BarChart v-loading.body="loading.chart" :data="chartdataroe" :width="500" :height="200"/>
                        </div>
                        <div class="mt-2">
                            <div class="text-center chart-title">Retun On Investment  %</div>
                            <BarChart v-loading.body="loading.chart" :data="chartdataroi" :width="500" :height="200"/>
                        </div>
                        <div class="mt-2">
                            <div class="text-center chart-title">Operating Profit Margin %</div>
                            <BarChart v-loading.body="loading.chart" :data="chartdataopm" :width="500" :height="200"/>
                        </div>
                        <div class="mt-2">
                            <div class="text-center chart-title">Net Profit Margin %</div>
                            <BarChart v-loading.body="loading.chart" :data="chartdatanpm" :width="500" :height="200"/>
                        </div>
                    </div>

                    <div :class="(String(this.description || '').trim().length > minLengthDescription ? 'col-md-4' : 'col-md-6' ) + ' '">
                        <div>
                            <div class="text-center chart-title">Cash Ratio %</div>
                            <BarChart v-loading.body="loading.chart" :data="chartdatacar" :width="500" :height="200"/>
                        </div>
                        <div class="mt-2">
                            <div class="text-center chart-title">Current Ratio %</div>
                            <BarChart v-loading.body="loading.chart" :data="chartdatacur" :width="500" :height="200"/>
                        </div>
                        <div class="mt-2">
                            <div class="text-center chart-title">Collection Period (hari)</div>
                            <BarChart v-loading.body="loading.chart" :data="chartdatacpd" :width="500" :height="200"/>
                        </div>
                        <div class="mt-2">
                            <div class="text-center chart-title">Inventory Turnover (hari)</div>
                            <BarChart v-loading.body="loading.chart" :data="chartdataitr" :width="500" :height="200"/>
                        </div>
                    </div>

                    <div class="col-md-4" v-if="String(this.description || '').trim().length > minLengthDescription">
                        <h6 class="text-center">HIGHLIGHT</h6>
                        <div class="p-2">
                            <div v-html="description"></div>
                            <!--
                            <ul>
                                <li class="text-justify">ROE Mei 2023 2,00%, 42% under target dari RKAP Ytd Maret 2023</li>
                                <li class="text-justify">ROI Mei 2022 1,77%, 32% under dari target RKAP Ytd Maret 2023</li>
                                <li class="text-justify">perating Profit Margin Mei 2022 0,45%, 59% under dari target RKAP Ytd Maret 2023</li>
                                <li class="text-justify">Net Profit Margin Mei 2023 sebesar 0,83%, atau 41% under dari target RKAP Ytd Maret 2023</li>
                                <li class="text-justify">Cash Ratio Mei 2023 sebesar 88,21%, atau 14% diatas target RKAP Ytd Mei 2023</li>
                                <li class="text-justify">Current Ratio Mei 2023 sebesar 109,52%, under 4% dari target RKAP Ytd Mei 2023</li>
                                <li class="text-justify">Collection Period Mei 2023 sebesar 1,68 hari, atau under 56% dari target RKAP Ytd Mei 2023</li>
                                <li class="text-justify">Inventory Turnover Mei 2023 sebesar 5,26 hari, atau under 11% dari target RKAP Ytd Mei 2023</li>                               
                            </ul>
                            -->
                            <Loader v-if="loading.description"/>
                        </div>
                    </div>
                </div>
            </el-card>

        </div>
        
    </div>
</template>

<script>
import KinerjaKeuangan from '@/components/page/KinerjaKeuangan.js'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'
import { Rainbow, FuelColor, Config, Penanggalan, AxiosWithJar } from '@/utility.js'
import Loader from '@/components/loader/Loader2.vue'

export default
{
	extends: KinerjaKeuangan,
	components: { 
        BarChart,
        Loader,
		//ReportParamSelect,
	},

	data() {
		return {
            columnWidth : 120,
            chartdata: [],
            loading: {
                table: false,
                chart: false,
                description: false,
            },

            month: ""+(Penanggalan().bulan-1),
            year: ""+Penanggalan().tahun,
            description: '',

            chartdataroe: [],
            chartdataroi: [],
            chartdataopm: [],
            chartdatanpm: [],
            chartdatacar: [],
            chartdatacur: [],
            chartdatacpd: [],
            chartdataitr: [],

            chartdataroesample: [
                {
                    label: 'Real Ytd Mei 2022',
                    legend: '',
                    valuecol: 9.96,
                },
                {
                    label: 'Real Ytd Mei 2023',
                    legend: '',
                    valuecol: 3.28,
                },
                {
                    label: 'RKAP Ytd Mei 2023',
                    legend: '',
                    valuecol: 5.75,
                },
                {
                    label: 'RKAP 2023',
                    legend: '',
                    valuecol: 13.80,
                },
            ],
        }
    },
    watch: {

	}, 
    mounted() {
        this.$emit('childrenRoute');
        //this.setChart()
        this.setDefaultPeriod()
        this.getChart()
        this.getDescription()
    },
    methods: {
        setChart() {
            this.chartdataroe = this.processBarChart(this.chartdataroesample, "legend", "", "valuecol", false, "label", "", 1, 2, Rainbow, false, false, false, false);
        },
        getChart() {
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/financial-performance/chart-rasio-keuangan?'
            
            this.urlRequestParams+='&year='+this.year
            this.urlRequestParams+='&month='+this.month

			this.loading.chart = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                let responseData = response.data;
                //this.chartdata1 = reportData.data

                let label = "legend"
                let legend = "label"

                this.chartdataroe = this.processBarChart(responseData.data.return_on_equity, legend, "", "value", false, label, "", 1, 2, this.colors, false, false, false, false);
                this.chartdataroi = this.processBarChart(responseData.data.return_on_investment, legend, "", "value", false, label, "", 1, 2, this.colors, false, false, false, false);
                this.chartdataopm = this.processBarChart(responseData.data.operating_profit_margin, legend, "", "value", false, label, "", 1, 2, this.colors, false, false, false, false);
                this.chartdatanpm = this.processBarChart(responseData.data.net_profit_margin, legend, "", "value", false, label, "", 1, 2, this.colors, false, false, false, false);
                this.chartdatacar = this.processBarChart(responseData.data.cash_ratio, legend, "", "value", false, label, "", 1, 2, this.colors, false, false, false, false);
                this.chartdatacur = this.processBarChart(responseData.data.current_ratio, legend, "", "value", false, label, "", 1, 2, this.colors, false, false, false, false);
                this.chartdatacpd = this.processBarChart(responseData.data.collection_period, legend, "", "value", false, label, "", 1, 2, this.colors, false, false, false, false);
                this.chartdataitr = this.processBarChart(responseData.data.inventory_turnover, legend, "", "value", false, label, "", 1, 2, this.colors, false, false, false, false);
                //console.log('data: ' + JSON.stringify(this.reportData))

                this.lastUpdate = responseData.data.last_update
            })
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.chart = false;
			})     

        },

        getDescription() {
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/financial-performance/tingkat-kesehatan-description?'
            
            this.urlRequestParams+='year='+this.year
            this.urlRequestParams+='&month='+this.month
            this.urlRequestParams+='&category=chart'

			this.loading.description = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                this.description = response.data.data.description;
                //console.log('data: ' + JSON.stringify(this.reportData))
            })
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.description = false;
			})     

        },

        applyFilter() {
            this.getChart()
            this.getDescription()
        },

    },
}
</script>

<style scoped>
.chart-title {
    background:#5B9BD5;
    color:#000;
    padding:2px;
}
</style>